import React from 'react';
import { Icons, ToggleGroup as UiToggleGroup, ToggleGroupItem } from '@ohif/ui-next';

const VALUES = ['yes', 'no'] as const;

const DEFAULT_LABELS = { on: 'Yes', off: 'No' };

interface ToggleGroupProps {
  value?: boolean;
  onChange: (value?: boolean) => void;
  disabled?: boolean;
  /** The group's accessible name. Required: a bare pair of radios announces nothing. */
  label: string;
  labels?: { on: string; off: string };
}

export default function ToggleGroup({
  value,
  onChange,
  disabled = false,
  label,
  labels = DEFAULT_LABELS,
}: ToggleGroupProps) {
  const selected = value === undefined ? '' : value ? 'yes' : 'no';

  return (
    <UiToggleGroup
      type="single"
      role="radiogroup"
      aria-label={label}
      value={selected}
      onValueChange={next => {
        if (disabled) {
          return;
        }
        onChange(next === '' ? undefined : next === 'yes');
      }}
      className="gap-2 bg-transparent"
      data-sycai-verdict={value === undefined ? 'unanswered' : 'answered'}
    >
      {VALUES.map(optionValue => (
        <ToggleGroupItem
          key={optionValue}
          value={optionValue}
          aria-disabled={disabled || undefined}
          className="h-auto w-auto gap-0.5 px-1 aria-disabled:opacity-70 text-foreground data-[state=on]:text-foreground hover:!text-foreground/80"
        >
          {selected === optionValue ? (
            <Icons.CheckBoxChecked
              aria-hidden="true"
              className="h-4 w-4"
            />
          ) : (
            <Icons.CheckBoxUnchecked
              aria-hidden="true"
              className="h-4 w-4"
            />
          )}
          <span className="text-xs">{optionValue === 'yes' ? labels.on : labels.off}</span>
        </ToggleGroupItem>
      ))}
    </UiToggleGroup>
  );
}
